document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-custom-tabs]').forEach((tabsRoot) => {
    if (tabsRoot.dataset.tabsInitialized === 'true') return;
    tabsRoot.dataset.tabsInitialized = 'true';

    const buttons = tabsRoot.querySelectorAll('.custom-tab-button');
    const panels = tabsRoot.querySelectorAll('.custom-tab-panel');

    buttons.forEach((button) => {
      button.addEventListener('click', function () {
        const targetId = this.getAttribute('aria-controls');

        buttons.forEach((btn) => {
          btn.classList.remove('active');
          btn.setAttribute('aria-selected', 'false');
        });

        panels.forEach((panel) => {
          panel.classList.remove('active');
        });

        this.classList.add('active');
        this.setAttribute('aria-selected', 'true');

        const targetPanel = tabsRoot.querySelector('#' + targetId);
        if (targetPanel) targetPanel.classList.add('active');
      });
    });

    // Auto-activate tab from URL hash on load
    const hash = window.location.hash;
    if (hash) {
      const cleanHash = hash.replace('#', '');
      const matchingButton = Array.from(buttons).find(btn => {
        const controls = btn.getAttribute('aria-controls') || '';
        return controls === cleanHash || controls === 'legal-' + cleanHash;
      });
      if (matchingButton) {
        matchingButton.click();
        // Smooth scroll to tabs section after a slight delay
        setTimeout(() => {
          tabsRoot.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  });
});
